<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">

                    <div class="col-12 mb-4">

                        <v-card>
                         <v-card-title>
                              Commandes 
                           </v-card-title>
                                            

                            <v-tabs
                                    v-model="tab"
                                    background-color="transparent"
                                    color="basil"
                                    grow
                            >
                                <v-tab
                                        v-for="item in items"
                                        :key="item"
                                >
                                    {{ item }}
                                </v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                                <v-tab-item
                                        key="Commandes en cours"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >

                                        <Commandecoursadmin />
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item
                                        key="Commandes effectuées"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >
                                        <Commandeeffectueadmin />
                                    </v-card>
                                </v-tab-item>

                            </v-tabs-items>
                        </v-card>


                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import Commandecoursadmin from "./Commandecoursadmin";
    import Commandeeffectueadmin from "./Commandeeffectueadmin";
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";

    export default {
        name: "Categorie",

        components: {Commandecoursadmin,Commandeeffectueadmin},
        data() {
            return {
                tab: null,
                items: [
                    'Commandes en cours', 'Commandes effectuées',
                ],
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',

                submitting: false,
                valid: true,
                lazy: false,
                errors: undefined,
                search: '',
                dialog: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                headers: [
                    {
                        text: 'Code',
                        align: 'start',
                        sortable: true,
                        value: 'code',
                    },
                    {text: 'Libellé', value: 'libel'},
                    {text: 'Actions', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                libelRules: [
                    v => !!v || 'Libellé requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || 'Code requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle catégorie" : "Mise à jour"
            }
            ,
            ...mapState('categories/', ['categories'])

        }
        ,
        mounted() {
            this.$store.dispatch('categories/getCategories').then(response => {
                window.console.log('categories', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            editItem(item) {
                this.editedIndex = this.categories.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }
            ,

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('categories/deleteCategorie', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("code", this.editedItem.code);
                data.append("libel", this.editedItem.libel);
                let mineroute = 'categories/setCategorie';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'categories/setUpdateCategorie';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>